import React, { useEffect, useRef, useState } from 'react'
import { Popup, Space, Button } from 'antd-mobile'
import '../css/Modifyprice.css'
import { CloseOutlined } from '@ant-design/icons'
import general, { redux } from '../../../../general'
import useActiveState from '../../../../lib/useActiveState'
import Dialog from '../../../../lib/Dialog'
export default function PriceChange(props) {

  const [visible, setVisible] = useState(false)
  const [user] = useActiveState('user')
  const [inputValue, setInputValue] = useState(0)
  const inputRef = useRef()

  useEffect(() => {
    setVisible(props.visible)
  }, [props.visible])

  const done = () => {
    if (!inputRef.current.value) {
      Dialog.error('请输入小号最新价格')
      return
    }
    Dialog.loading()
    general.axios.post('/changeTradePrice', {
      trade_id: props.trade.trade_id,
      current_price: inputRef.current.value
    }).finally(() => {
      Dialog.close()
    }).then(res => {
      const { status } = res.data
      if (status.succeed) {
        redux.dispatch({
          type: 'updateTradePrice',
          data: {
            trade_id: props.trade.trade_id,
            current_price: inputRef.current.value
          }
        })
        if (props.updatePrice) {
          props.updatePrice(inputRef.current.value)
        }
        const value = inputRef.current.value
        inputRef.current.value = ''
        setInputValue(0)
        props.handleDismiss()
        Dialog.alert(`已修改价格为${value}元`)
      } else {
        Dialog.error(status.error_desc)
      }
    })

  }

  return (
    <div>
      <Popup
        visible={visible}
        bodyStyle={{
          borderTopLeftRadius: '13px',
          borderTopRightRadius: '13px',
        }}
      >
        <div className='bargain-index'>
          <div className="close" onClick={() => {
            setInputValue(0)
            inputRef.current.value = ''
            props.handleDismiss()
          }}>
            <CloseOutlined></CloseOutlined>
          </div>
          <div className="header">
            <div className="title">改价</div>
            <div className="desc">同一个出售的小号每天最多可改价3次</div>
          </div>
          <div className="container">
            <div className="item">
              <div className="title">商品原价</div>
              <div className="title">￥{props.trade.sell_price}</div>
            </div>
            <div className="item">
              <div className="title">最新价格</div>
              <input ref={inputRef} maxLength={6} onChange={e => {
                setInputValue(e.target.value)
              }} className='title input' type="text" pattern='[0-9]*' placeholder='请输入小号最新价格' />
            </div>
            <div className="item">
              <div className="title">出售可得<span className='desc'>（{(()=>{
                if (parseInt(user.vip_level) == 1){
                  return '会员月卡'
                }else if (parseInt(user.vip_level) == 2){
                  return '会员季卡'
                }else if (parseInt(user.vip_level) == 3){
                  return '会员年卡'
                }
              })()}手续费{user?.tradeRate * 100}%，最低1元）</span></div>
              {inputValue > 0 && <div className="value">
                {(() => {
                  let value = inputValue * 10;
                  // let fee = value * 0.05;
                  let fee = value * user?.tradeRate;
                  if (fee < 10) {
                    fee = 10;
                  }

                  let number = 0;
                  if (Number(value) >= Number(fee)) {
                    number = value - fee || 0;
                  }

                  return number;
                })()}
                平台币
              </div>}
            </div>
          </div>
          <div className="done" onClick={done}>改价</div>
        </div>
      </Popup>
    </div>
  )
}
